import { render } from "./PasswordLostComponent.vue?vue&type=template&id=b3a46614"
import script from "./PasswordLostComponent.vue?vue&type=script&lang=js"
export * from "./PasswordLostComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apiffare/projects/aldes/apps/aldes-learning-support-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__